import { render, staticRenderFns } from "./SpecialRfDgDownloadPop.vue?vue&type=template&id=c7060172"
import script from "./SpecialRfDgDownloadPop.vue?vue&type=script&lang=js"
export * from "./SpecialRfDgDownloadPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7060172')) {
      api.createRecord('c7060172', component.options)
    } else {
      api.reload('c7060172', component.options)
    }
    module.hot.accept("./SpecialRfDgDownloadPop.vue?vue&type=template&id=c7060172", function () {
      api.rerender('c7060172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/SpecialRfDgDownloadPop.vue"
export default component.exports